import React, { PropTypes } from 'react';
// Componentes
import ExhibitorsContainer from '../../../containers/ExhibitorsContainer';
import ExhibitorDetailsContainer from '../../../containers/ExhibitorDetailsContainer';


const propTypes = {
  params: PropTypes.object,
};

const Exhibitors = ({ params: { id } }) => (
  <div>
    <div className="ui hidden divider" />
    <ExhibitorsContainer key={2} />
    {
      id &&
        <ExhibitorDetailsContainer key={1} id={id} />
    }
  </div>
);

Exhibitors.propTypes = propTypes;

export default Exhibitors;



/** WEBPACK FOOTER **
 ** ./src/components/screens/exhibitors/Exhibitors.js
 **/